export default __webpack_public_path__ + "static/media/01_FFg.15084686.png";